import { Devices } from "@mui/icons-material";
import { ClickAwayListener, IconButton } from "@mui/material";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { anyAvailableDevice, anyPointedDevice } from "../../../reducers/devices";
import { anyDisablingProcess } from "../../../reducers/disablingProcesses";
import DeviceList from "./DeviceList";

const DeviceSelector = ({size}) => {
    const [windowOpen, setWindowOpen] = useState(false);
    const anyDevice = useSelector(anyAvailableDevice);
    const pointedDevice = useSelector(anyPointedDevice);
    const disabled = useSelector(anyDisablingProcess);

    const onClick = () => setWindowOpen(!windowOpen);
    const closeWindow = () => setWindowOpen(false);

    const buttonRef = useRef();
    
    return (
        <ClickAwayListener onClickAway={closeWindow}>
            <div className="relative-position">
                <DeviceList
                    open={!disabled && (windowOpen || (anyDevice && !pointedDevice))}
                    anchor={buttonRef && buttonRef.current}
                    closeHandler={closeWindow} />
                <IconButton disabled={disabled} onClick={onClick} size={size} ref={buttonRef}>
                    <Devices htmlColor={windowOpen ? "white" : undefined} fontSize={size} />
                </IconButton>
            </div>
        </ClickAwayListener>
    )
}

export default DeviceSelector;